import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";

import { Container, BackButton } from './TemplateBuilder.styles';
import SheetBuilder from './SheetBuilder/SheetBuilder';
import SheetProps from './SheetProps/SheetProps'; 
import FileManager from '../Table/FileManager/FileManager'; 
import { getStatus } from '../../services/profile';

export default () => {

    const history = useHistory();

    const handleBack = () => {
        history.goBack();
    };

    useEffect(() => {
        (async () => {
            await getStatus();
        })();
    }, []);

    return <Container>
        <FileManager />
        <BackButton onClick={()=>{handleBack()}} />
        <SheetBuilder />
        <SheetProps />
    </Container>
};